import * as RouteHelper from "@utils/paths";
import { ContractorPackageLineItem } from "catchment-common/interfaces/contractorPackage";
import { ProjectLineItem } from "catchment-common/interfaces/project";
import { NavItemType } from "types";

import { safeUrl } from "./menuItemUrl";
import Icon from "@ui/atoms/Icon/Icon";

export const getDirectoryNav = (
  project?: ProjectLineItem,
  contractorPackage?: ContractorPackageLineItem
): NavItemType => {
  return {
    children: [
      {
        icon: <Icon name="download" />,
        id: "export-generator",
        title: "Export Generator",
        type: "item",
        url: safeUrl(project, contractorPackage, () =>
          RouteHelper.createExport(project!.id, contractorPackage!.id)
        )
      },
      {
        icon: <Icon name="file-search" />,
        id: "smart-directory",
        title: "Smart Directory",
        type: "item",
        url: safeUrl(project, contractorPackage, () =>
          RouteHelper.smartDirectory(project!.id, contractorPackage!.id)
        )
      }
    ],
    // The id stays: `resolveProjectSelectedItem` and the tests read it.
    id: "search",
    title: "View",
    type: "group"
  };
};
